import React, { useContext, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby-link'

import { ContextHeadline } from '@aok/text-elements'
import { collapsable } from '@aok/accordion'
import { ArrowRoundedDown } from '@aok/icon-functional'
import { Link } from '@aok/ui-elements'

import SearchAutocomplete from '../../molecules/SearchAutocomplete/SearchAutocomplete'
import ModuleContainer from '../../_layout/Module/ModuleContainer'
import StructureMenu from '../../molecules/StructureMenu/StructureMenu'

import { handleAutocompleteRequest } from '../../../utils/requests/handleAutocompleteRequest'
import { APIContext } from '../../../context/APIContext'
import { getEnvironment } from '../../../utils/appUtils'

const Y008 = ({ headline, structureList, openDropdown }) => {
  const apiContext = useContext(APIContext)
  const [api] = useState({
    autocompleteUrl: apiContext[getEnvironment('AUTOCOMPLETE_URL') || ''],
    frequentlySearchedUrl: apiContext[getEnvironment('FREQUENTLY_SEARCHED_URL') || ''],
  })

  const collapsableRef = useRef(null)
  const collapsableRefTarget = useRef(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(openDropdown)

  useEffect(() => {
    if (openDropdown) {
      collapsable(collapsableRef.current, collapsableRefTarget.current)
    }
  }, [openDropdown])

  const handleRequestAutocompleteData = (query, successCallback) => {
    handleAutocompleteRequest(api.autocompleteUrl, query, successCallback)
  }

  const submitSearch = (value) => {
    value = value.replaceAll('&', 'und')
    navigate(`/suche/?q=${encodeURI(value)}`)
  }

  return (
    <div className="bg-005e3f" data-tracking-name="Y008">
      <ModuleContainer
        className="
          grid
          grid-cols-4 gap-16
          600:grid-cols-8
          720:gap-24
          840:grid-cols-12
          1000:gap-32
          py-48 600:py-80 840:py-112
        "
      >
        <div
          className="
            col-span-full
            600:col-start-2 600:col-end-8
            840:col-start-3 840:col-end-11
          "
        >
          <ContextHeadline
            text={headline.text}
            className="
              text-ffffff text-center
              text-28 1280:text-32
              leading-36 1280:leading-44
              mb-32
              font-buenos-aires font-semibold
            "
          />
          <SearchAutocomplete
            autocompleteProps={{
              variant: 'dark',
            }}
            className="mb-40 600:mb-48"
            searchFieldProps={{
              id: 'Y008-searchField-input',
              labelVisibility: 'hide',
              inputProps: {
                placeholder: 'Magazin durchsuchen',
              },
              variant: 'dark',
            }}
            onSubmit={submitSearch}
            onSelect={submitSearch}
            onRequestAutocompleteData={handleRequestAutocompleteData}
          />

          <Link
            ref={collapsableRef}
            type="button"
            title={isDropdownOpen ? 'Themenübersicht ausblenden' : 'Themenübersicht einblenden'}
            onClick={() => {
              const newOpenState = collapsable(collapsableRef.current, collapsableRefTarget.current)
              setIsDropdownOpen(newOpenState)
            }}
            theme="secondary"
            variant="dark"
            icon={<ArrowRoundedDown className={`fill-current w-16 h-16 ml-8 ${isDropdownOpen ? 'rotate-180' : ''}`} />}
            className="flex items-center mx-auto"
          />

          <div
            className="
              h-0 overflow-hidden
              transition-all duration-500 ease-in-out
            "
            aria-live="polite"
            ref={collapsableRefTarget}
          >
            <StructureMenu className="mt-24 600:mt-32 840:mt-48" structureList={structureList} />
          </div>
        </div>
      </ModuleContainer>
    </div>
  )
}

Y008.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
  }),
  structureList: PropTypes.array,
  openDropdown: PropTypes.bool,
}

Y008.defaultProps = {
  headline: {
    text: 'Lorem Ipsum',
  },
  structureList: [],
  openDropdown: false,
}

export default Y008
